import { flatMap, has } from "lodash";
import { useReducer } from "react";
import toast from "react-hot-toast";
import api from "../../apis/axiosInterceptor";

interface Master {
  masterData: object;
  settingMasterData: any;
  DocumentMasterData: object;
  DropdownMasterData: object;
  SettingCategoryOptions: object;
  documentMasterEditData: object;
  SettingMasterEditData: object;
  error: string;
}

const initialArgs: Master = {
  masterData: {},
  settingMasterData: [],
  DocumentMasterData: {},
  DropdownMasterData: {},
  SettingCategoryOptions: {},
  documentMasterEditData: {},
  SettingMasterEditData: {},
  error: "",
};

const reducer = (state: Master, action: Master) => {
  return { ...state, ...action };
};

const useSettingCategory = () => {
  const [state, setState] = useReducer(reducer, initialArgs);

  const getDocumentMaster = async () => {
    try {
      const result: any = await api.get(
        `/api/setting-category/type?slug=document`,
      );

      if (result.data.status) {
        setState({
          ...state,
          DocumentMasterData: result.data.data,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const getSettingCategory = async (
    page: string,
    pageSize: string,
    searchText: string,
    sort: string,
    order: string,
  ) => {
    try {
      const result: any = await api.get(
        `/api/setting-category?page=${page}&pageSize=${pageSize}&searchValue=${searchText}&sort=${sort}&order=${order}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          settingMasterData: result.data.data[0],
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const getDropdownMaster = async (
    page: string,
    pageSize: string,
    searchText: string,
    sort: string,
    order: string,
  ) => {
    try {
      const result: any = await api.get(
        `/api/setting?page=${page}&pageSize=${pageSize}&searchValue=${searchText}&sort=${sort}&order=${order}`,
      );

      if (result.data.status) {
        setState({
          ...state,
          DropdownMasterData: result.data.data,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const getSettingCategoryMasterOptions = async () => {
    try {
      const result: any = await api.get(`/api/setting-slug`);

      if (result.data.status) {
        setState({
          ...state,
          SettingCategoryOptions: result.data.data,
        });

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const updateSettingCategory = async (param: any, dropdownid: any) => {
    const paramObj = {
      ...param,
    };

    try {
      const result: any = await api.put(
        `/api/setting-category/${dropdownid}`,
        paramObj,
      );

      if (result.data.status) {
        // setState({ ...state, documentMasterEditData: result.data.data });
        toast.success("Setting Created Updated Successfully");
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const editSettingCategory = async (dropdownMasterId: string) => {
    try {
      const result: any = await api.get(
        `/api/setting-category/${dropdownMasterId}`,
      );

      if (result.data.status) {
        setState({ ...state, SettingMasterEditData: result.data.data });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };
  const createSettingCategory = async (param: any) => {
    const paramObj = {
      ...param,
    };

    try {
      // const formData = new FormData();
      const result: any = await api.post("/api/setting-category", paramObj);

      if (result.data.status) {
        // toast.success(result.data.message);
        toast.success("Setting Category has been Added Successfully");
        setState({ ...state, masterData: result.data.data });
        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        setState({ ...state, error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      setState({ ...state, error: error.message });
      return false;
    }
  };

  return {
    getDocumentMaster,
    getSettingCategory,
    getDropdownMaster,
    updateSettingCategory,
    getSettingCategoryMasterOptions,
    editSettingCategory,
    createSettingCategory,
    ...state,
  };
};

export default useSettingCategory;
